// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__fxKzb","popup_inner":"styles_popup_inner__m1XPA","blue_inner":"styles_blue_inner__Yk-L8","text":"styles_text__olJ2x","right":"styles_right__OcYmx"};